import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin/berita" replace />;

  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setError("");
    try { await login(email, password); toast.success("Berhasil masuk"); nav("/admin/berita"); }
    catch (err) { setError(errMsg(err)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative bg-slate-950">
        <img src="https://images.unsplash.com/photo-1498644035638-2c3357894b10?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080" alt="" className="absolute inset-0 w-full h-full object-cover opacity-50" />
        <div className="absolute bottom-12 left-12 right-12 text-white">
          <p className="text-xs font-bold tracking-[0.2em] uppercase text-red-400">Ruang Redaksi</p>
          <h2 className="font-serif text-4xl font-extrabold mt-3">Tulis, kelola, dan terbitkan berita.</h2>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6 fade-up" data-testid="login-form">
          <Link to="/" className="font-serif text-3xl font-extrabold">Kabar<span className="text-[#C8102E]">Nusa</span></Link>
          <p className="text-slate-500 text-sm">Masuk ke dasbor admin</p>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Kata Sandi</Label>
            <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" />
          </div>
          {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
          <Button type="submit" disabled={busy} className="w-full h-11 uppercase tracking-widest text-xs font-bold" data-testid="login-submit-button">
            {busy ? "Memproses..." : "Masuk"}
          </Button>
        </form>
      </div>
    </div>
  );
}
